package com.schoolconnect.app.designsystem.list

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.hoverable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.interaction.collectIsFocusedAsState
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.selection.selectable
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.gestures.detectDragGestures
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import com.schoolconnect.app.designsystem.AdminSummaryMetrics
import com.schoolconnect.app.designsystem.AppDropdownMenu
import com.schoolconnect.app.designsystem.AppToastCenter
import com.schoolconnect.app.runtime.AppErrorCenter
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.tween
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.material3.Surface
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.runtime.getValue
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.clipToBounds
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.onClick
import androidx.compose.ui.semantics.role
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.sp
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.ban
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.chevron_left
import ischoolconnect.sharedui.generated.resources.chevron_right
import ischoolconnect.sharedui.generated.resources.chevron_up
import ischoolconnect.sharedui.generated.resources.double_chevron_left
import ischoolconnect.sharedui.generated.resources.double_chevron_right
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.close_x
import ischoolconnect.sharedui.generated.resources.eye
import ischoolconnect.sharedui.generated.resources.pencil
import ischoolconnect.sharedui.generated.resources.search
import ischoolconnect.sharedui.generated.resources.trash
import org.jetbrains.compose.resources.painterResource
import com.schoolconnect.app.feature.common.PaginationPolicy

data class AdminListSortColumn(
    val label: String,
    val weight: Float,
    val selected: Boolean,
    val ascending: Boolean,
    val sortable: Boolean = true,
    val alignCenter: Boolean = false,
    val onClick: () -> Unit = {}
)

data class AdminListHeaderColumn(
    val label: String,
    val weight: Float,
    val trailingContent: (@Composable () -> Unit)? = null,
    val onClick: (() -> Unit)? = null,
    val alignEnd: Boolean = false,
    val alignCenter: Boolean = false
)

data class AdminListSpreadsheetCell(
    val weight: Float,
    val alignEnd: Boolean = false,
    val content: @Composable () -> Unit
)

data class AdminListRowAction(
    val label: String,
    val onClick: () -> Unit,
    val icon: Painter? = null,
    val iconTint: Color? = null,
    val labelColor: Color? = null
)

data class AdminRowActionItem(
    val label: String,
    val onClick: () -> Unit,
    val icon: Painter? = null,
    val iconTint: Color? = null,
    val labelColor: Color? = null
)

data class AdminListSummaryCardItem(
    val title: String,
    val value: String,
    val subtitle: String,
    val icon: Painter,
    val accent: Color,
    val accentBg: Color,
    val subtitleColor: Color,
    val surfaceColor: Color = AdminListDefaults.Surface,
    val borderColor: Color = AdminListDefaults.Border,
    val textColor: Color = AdminListDefaults.Navy,
    val valueFontSize: TextUnit = AdminListTypography.SummaryValue
)

private class AdminListActiveFilterHost {
    var chips by mutableStateOf(emptyList<String>())
    var onClearAll by mutableStateOf<(() -> Unit)?>(null)
    var onRemoveChip by mutableStateOf<((String) -> Unit)?>(null)
    var backgroundColor by mutableStateOf(Color(0xFFF2F7FF))
    var contentColor by mutableStateOf(AdminListDefaults.Navy)
    var accentColor by mutableStateOf(AdminListDefaults.Primary)
}

private val LocalAdminListActiveFilterHost =
    compositionLocalOf<AdminListActiveFilterHost?> { null }

@Composable
fun AdminListPageScaffold(
    title: String,
    subtitle: String,
    summaryCards: @Composable RowScope.() -> Unit,
    topContent: @Composable ColumnScope.() -> Unit = {},
    headerActions: @Composable RowScope.() -> Unit = {},
    secondaryHeader: (@Composable RowScope.() -> Unit)? = null,
    breadcrumb: List<String> = emptyList(),
    showTitleBlock: Boolean = true,
    showSummaryCards: Boolean = true,
    /** When set, drawn instead of [subtitle] so spans (e.g. bold counts) are supported. */
    subtitleAnnotated: AnnotatedString? = null,
    toolbar: @Composable () -> Unit,
    table: @Composable (Modifier) -> Unit,
    bottomAction: @Composable RowScope.() -> Unit,
    modifier: Modifier = Modifier,
    banner: @Composable ColumnScope.() -> Unit = {},
    backgroundColor: Color = AdminListDefaults.Background,
    titleColor: Color = AdminListDefaults.PageTitleColor,
    subtitleColor: Color = AdminListDefaults.PageSubtitleColor,
    maxContentWidth: Dp = 1210.dp,
    sectionSpacing: Dp = 24.dp,
    bannerAfterToolbar: Boolean = false
) {
    val activeFilterHost = remember { AdminListActiveFilterHost() }
    BoxWithConstraints(
        modifier = modifier
            .fillMaxSize()
            .background(backgroundColor)
    ) {
        val compact = maxWidth < 700.dp
        CompositionLocalProvider(LocalAdminListActiveFilterHost provides activeFilterHost) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .fillMaxWidth()
                .padding(horizontal = 24.dp, vertical = 24.dp)
                .widthIn(max = maxContentWidth)
                .then(if (compact) Modifier.verticalScroll(rememberScrollState()) else Modifier),
            verticalArrangement = Arrangement.spacedBy(sectionSpacing)
        ) {
            topContent()

            if (showTitleBlock) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.Top
                ) {
                    Column(
                        modifier = Modifier.weight(1f),
                        verticalArrangement = Arrangement.spacedBy(4.dp)
                    ) {
                        AdminListBreadcrumb(
                            items = breadcrumb.ifEmpty { listOf("Dashboard", title) }
                        )
                        Text(
                            text = title,
                            fontSize = AdminListTypography.PageTitle,
                            fontWeight = AdminListTypography.PageTitleWeight,
                            color = titleColor,
                            modifier = Modifier.fillMaxWidth()
                        )
                        if (subtitleAnnotated != null) {
                            Text(
                                text = subtitleAnnotated,
                                fontSize = AdminListTypography.PageSubtitle,
                                color = subtitleColor,
                                fontWeight = AdminListTypography.PageSubtitleWeight
                            )
                        } else {
                            Text(
                                text = subtitle,
                                fontSize = AdminListTypography.PageSubtitle,
                                color = subtitleColor,
                                fontWeight = AdminListTypography.PageSubtitleWeight
                            )
                        }
                    }
                    Row(
                        horizontalArrangement = Arrangement.End,
                        verticalAlignment = Alignment.Top,
                        content = headerActions
                    )
                }
            }

            secondaryHeader?.let { content ->
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.Bottom,
                    content = content
                )
            }

            if (showSummaryCards) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(16.dp),
                    content = summaryCards
                )
            }

            if (!bannerAfterToolbar) banner()
            toolbar()
            if (bannerAfterToolbar) banner()
            table(
                if (compact) {
                    Modifier.fillMaxWidth().height(360.dp)
                } else {
                    Modifier.fillMaxWidth().weight(1f)
                }
            )

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically,
                content = bottomAction
            )
        }
        }
    }
}

@Composable
fun AdminListBreadcrumb(
    items: List<String>,
    modifier: Modifier = Modifier,
    currentColor: Color = AdminListDefaults.Navy,
    mutedColor: Color = AdminListDefaults.Muted
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(6.dp)
    ) {
        items.forEachIndexed { index, item ->
            if (index > 0) {
                Icon(
                    painter = painterResource(Res.drawable.chevron_right),
                    contentDescription = null,
                    tint = mutedColor,
                    modifier = Modifier.size(12.dp)
                )
            }
            Text(
                text = item,
                fontSize = 12.sp,
                color = if (index == items.lastIndex) currentColor else mutedColor,
                fontWeight = if (index == items.lastIndex) FontWeight.SemiBold else FontWeight.Normal
            )
        }
    }
}

@Composable
fun AdminListSummaryCard(
    title: String,
    value: String,
    subtitle: String,
    icon: Painter,
    accent: Color,
    accentBg: Color,
    subtitleColor: Color,
    modifier: Modifier = Modifier,
    surfaceColor: Color = AdminListDefaults.Surface,
    borderColor: Color = AdminListDefaults.Border,
    textColor: Color = AdminListDefaults.Navy,
    cardHeight: Dp = 104.dp,
    contentPadding: PaddingValues = PaddingValues(horizontal = 12.dp, vertical = 12.dp),
    iconSize: Dp = 48.dp,
    iconGlyphSize: Dp = 24.dp,
    contentSpacing: Dp = 8.dp,
    titleFontSize: TextUnit = AdminListTypography.SummaryTitle,
    valueFontSize: TextUnit = AdminListTypography.SummaryValue,
    subtitleFontSize: TextUnit = AdminListTypography.SummarySubtitle
) {
    Card(
        modifier = modifier.height(cardHeight),
        shape = AdminListDefaults.CornerShape,
        colors = CardDefaults.cardColors(containerColor = surfaceColor),
        border = androidx.compose.foundation.BorderStroke(1.dp, borderColor)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(contentPadding),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(contentSpacing)
        ) {
            Box(
                modifier = Modifier
                    .size(iconSize)
                    .background(accentBg, AdminListDefaults.CornerShape),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    painter = icon,
                    contentDescription = title,
                    tint = accent,
                    modifier = Modifier.size(iconGlyphSize)
                )
            }
            Column(
                modifier = Modifier.weight(1f),
                verticalArrangement = Arrangement.spacedBy(4.dp)
            ) {
                Text(
                    text = title,
                    style = MaterialTheme.typography.titleSmall.copy(fontSize = titleFontSize),
                    color = textColor,
                    fontWeight = AdminListTypography.SummaryTitleWeight,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = value,
                    style = MaterialTheme.typography.headlineSmall.copy(fontSize = valueFontSize),
                    color = textColor,
                    fontWeight = AdminListTypography.SummaryValueWeight,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = subtitle,
                    style = MaterialTheme.typography.bodyMedium.copy(fontSize = subtitleFontSize),
                    color = subtitleColor,
                    fontWeight = AdminListTypography.SummarySubtitleWeight,
                    maxLines = 2,
                    overflow = TextOverflow.Clip
                )
            }
        }
    }
}

@Composable
fun RowScope.AdminListSummaryCards(
    items: List<AdminListSummaryCardItem>,
    modifier: Modifier = Modifier,
    cardHeight: Dp = 104.dp,
    iconSize: Dp = 48.dp,
    iconGlyphSize: Dp = 24.dp,
    contentSpacing: Dp = 8.dp,
    columnSpacing: Dp = 16.dp,
    titleFontSize: TextUnit = AdminListTypography.SummaryTitle,
    subtitleFontSize: TextUnit = AdminListTypography.SummarySubtitle,
    contentPadding: PaddingValues = PaddingValues(horizontal = 12.dp, vertical = 12.dp),
    /** When true, paint cards from the shared 4-tone cycle so neighbors do not match. */
    alternateColors: Boolean = true
) {
    BoxWithConstraints(modifier = Modifier.weight(1f).then(modifier).fillMaxWidth()) {
        val columns = when {
            maxWidth < 560.dp -> 2
            maxWidth < 960.dp -> 3
            else -> items.size.coerceAtLeast(1)
        }
        AdminListCardGrid(
            items = items.mapIndexed { index, item ->
                if (!alternateColors) {
                    item
                } else {
                    val tone = AdminSummaryMetrics.gridTone(index, columns)
                    item.copy(
                        accent = tone.accent,
                        accentBg = Color.White.copy(alpha = 0.72f),
                        surfaceColor = tone.soft,
                        borderColor = AdminSummaryMetrics.CardBorder
                    )
                }
            },
            columns = columns,
            rowSpacing = 12.dp,
            columnSpacing = columnSpacing
        ) { item, itemModifier ->
            AdminListSummaryCard(
                title = item.title,
                value = item.value,
                subtitle = item.subtitle,
                icon = item.icon,
                accent = item.accent,
                accentBg = item.accentBg,
                subtitleColor = item.subtitleColor,
                surfaceColor = item.surfaceColor,
                borderColor = item.borderColor,
                textColor = item.textColor,
                valueFontSize = item.valueFontSize,
                cardHeight = cardHeight,
                iconSize = iconSize,
                iconGlyphSize = iconGlyphSize,
                contentSpacing = contentSpacing,
                titleFontSize = titleFontSize,
                subtitleFontSize = subtitleFontSize,
                contentPadding = contentPadding,
                modifier = itemModifier
            )
        }
    }
}

@Composable
fun <T> AdminListCardGrid(
    items: List<T>,
    columns: Int = 3,
    modifier: Modifier = Modifier,
    rowSpacing: Dp = 14.dp,
    columnSpacing: Dp = 14.dp,
    itemContent: @Composable (item: T, modifier: Modifier) -> Unit
) {
    if (items.isEmpty()) return

    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.spacedBy(rowSpacing)
    ) {
        items.chunked(columns.coerceAtLeast(1)).forEach { rowItems ->
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(columnSpacing)
            ) {
                rowItems.forEach { item ->
                    itemContent(item, Modifier.weight(1f))
                }
                repeat(columns.coerceAtLeast(1) - rowItems.size) {
                    Spacer(modifier = Modifier.weight(1f))
                }
            }
        }
    }
}

@Composable
fun <T> AdminListStaggeredCardGrid(
    items: List<T>,
    columns: Int = 3,
    modifier: Modifier = Modifier,
    rowSpacing: Dp = 14.dp,
    columnSpacing: Dp = 14.dp,
    itemContent: @Composable (item: T, modifier: Modifier) -> Unit
) {
    val laneCount = columns.coerceAtLeast(1)
    if (items.isEmpty()) return

    val lanes = remember(items, laneCount) {
        List(laneCount) { laneIndex ->
            items.filterIndexed { index, _ -> index % laneCount == laneIndex }
        }
    }

    Row(
        modifier = modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(columnSpacing),
        verticalAlignment = Alignment.Top
    ) {
        lanes.forEach { laneItems ->
            Column(
                modifier = Modifier.weight(1f),
                verticalArrangement = Arrangement.spacedBy(rowSpacing)
            ) {
                laneItems.forEach { item ->
                    itemContent(item, Modifier.fillMaxWidth())
                }
            }
        }
    }
}

@Composable
fun AdminListStatCardShell(
    modifier: Modifier = Modifier,
    surfaceColor: Color = AdminListDefaults.Surface,
    borderColor: Color = AdminListDefaults.Border,
    minHeight: Dp = 180.dp,
    contentPadding: PaddingValues = PaddingValues(18.dp),
    content: @Composable ColumnScope.() -> Unit
) {
    Card(
        modifier = modifier.heightIn(min = minHeight),
        shape = AdminListDefaults.CornerShape,
        colors = CardDefaults.cardColors(containerColor = surfaceColor),
        border = androidx.compose.foundation.BorderStroke(1.dp, borderColor)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(contentPadding),
            verticalArrangement = Arrangement.spacedBy(14.dp),
            content = content
        )
    }
}

@Composable
fun AdminListPanelHeader(
    title: String,
    actionLabel: String? = null,
    modifier: Modifier = Modifier,
    horizontalPadding: Dp = 20.dp,
    verticalPadding: Dp = 14.dp,
    titleColor: Color = AdminListDefaults.Navy,
    actionColor: Color = AdminListDefaults.Primary,
    actionFontSize: TextUnit = 14.sp
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = horizontalPadding, vertical = verticalPadding),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = title,
            style = MaterialTheme.typography.titleMedium,
            fontWeight = FontWeight.Bold,
            color = titleColor
        )
        if (actionLabel != null) {
            Text(
                text = actionLabel,
                style = MaterialTheme.typography.bodyMedium.copy(fontSize = actionFontSize),
                fontWeight = FontWeight.Bold,
                color = actionColor
            )
        }
    }
}

@Composable
fun AdminListPrimaryActionButton(
    label: String,
    icon: Painter,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    backgroundColor: Color = AdminListDefaults.Primary,
    contentColor: Color = Color.White
) {
    Row(
        modifier = modifier
            .height(40.dp)
            .background(backgroundColor, androidx.compose.foundation.shape.RoundedCornerShape(6.dp))
            .clickable(onClick = onClick)
            .padding(horizontal = 16.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    ) {
        Icon(
            painter = icon,
            contentDescription = label,
            tint = contentColor,
            modifier = Modifier.size(16.dp)
        )
        Spacer(modifier = Modifier.width(8.dp))
        Text(
            text = label,
            color = contentColor,
            fontSize = 14.sp,
            fontWeight = FontWeight.Medium,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
fun AdminListToolbar(
    searchQuery: String,
    onSearchQueryChanged: (String) -> Unit,
    searchPlaceholder: String,
    modifier: Modifier = Modifier,
    searchWidth: Dp = 370.dp,
    height: Dp = 40.dp,
    surfaceColor: Color = AdminListDefaults.Surface,
    borderColor: Color = AdminListDefaults.Border,
    searchIconTint: Color = AdminListDefaults.Muted,
    searchTextColor: Color = AdminListDefaults.Navy,
    searchCursorColor: Color = AdminListDefaults.Primary,
    searchTopPadding: Dp = 0.dp,
    compactBreakpoint: Dp = 1100.dp,
    inlineContent: @Composable RowScope.() -> Unit = {},
    actions: @Composable RowScope.() -> Unit
) {
    val activeFilterHost = LocalAdminListActiveFilterHost.current
    BoxWithConstraints(modifier = modifier.fillMaxWidth()) {
        // Leave enough room for search, inline filters, and toolbar actions before
        // switching layouts. Fixed-width filters and buttons otherwise get clipped
        // at common tablet and split-window widths.
        val compact = maxWidth < compactBreakpoint
        val resolvedSearchWidth = if (compact) maxWidth else minOf(searchWidth, maxWidth * 0.4f)
        Column(verticalArrangement = Arrangement.spacedBy(if (compact) 8.dp else 0.dp)) {
            Row(
                modifier = Modifier.fillMaxWidth().heightIn(min = height),
                verticalAlignment = Alignment.Bottom,
                horizontalArrangement = Arrangement.Start
            ) {
                AdminListSearchField(
                    value = searchQuery,
                    onValueChange = onSearchQueryChanged,
                    placeholder = searchPlaceholder,
                    width = resolvedSearchWidth,
                    surfaceColor = surfaceColor,
                    borderColor = borderColor,
                    iconTint = searchIconTint,
                    textColor = searchTextColor,
                    cursorColor = searchCursorColor,
                    modifier = Modifier.padding(top = searchTopPadding)
                )
                if (!compact) {
                    Spacer(modifier = Modifier.width(8.dp))
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(8.dp),
                        verticalAlignment = Alignment.Bottom,
                        content = inlineContent
                    )
                    Spacer(modifier = Modifier.weight(1f))
                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.Bottom) {
                        actions()
                    }
                }
            }
            if (compact) {
                Row(
                    modifier = Modifier.fillMaxWidth().horizontalScroll(rememberScrollState()),
                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                    verticalAlignment = Alignment.Bottom,
                    content = {
                        inlineContent()
                        actions()
                    }
                )
            }
            activeFilterHost?.takeIf { it.chips.isNotEmpty() }?.let { host ->
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    Row(
                        modifier = Modifier.weight(1f).horizontalScroll(rememberScrollState()),
                        horizontalArrangement = Arrangement.spacedBy(6.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        host.chips.forEach { chip ->
                            Surface(
                                color = Color.Transparent,
                                shape = AdminListDefaults.CornerShape,
                                border = androidx.compose.foundation.BorderStroke(1.dp, host.accentColor.copy(alpha = 0.28f))
                            ) {
                                Row(
                                    modifier = Modifier.padding(start = 8.dp, end = 2.dp),
                                    verticalAlignment = Alignment.CenterVertically,
                                    horizontalArrangement = Arrangement.spacedBy(2.dp)
                                ) {
                                    Text(
                                        text = chip,
                                        color = host.contentColor,
                                        fontSize = 12.sp,
                                        maxLines = 1,
                                        overflow = TextOverflow.Ellipsis
                                    )
                                    if (host.onRemoveChip != null) {
                                        IconButton(
                                            onClick = {
                                                host.chips = host.chips - chip
                                                host.onRemoveChip?.invoke(chip)
                                            },
                                            modifier = Modifier.size(24.dp)
                                        ) {
                                            Icon(
                                                painter = painterResource(Res.drawable.close_x),
                                                contentDescription = "Remove $chip filter",
                                                tint = host.contentColor,
                                                modifier = Modifier.size(12.dp)
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun AdminListSearchField(
    value: String,
    onValueChange: (String) -> Unit,
    placeholder: String,
    modifier: Modifier = Modifier,
    width: Dp = 370.dp,
    height: Dp = 40.dp,
    surfaceColor: Color = AdminListDefaults.Surface,
    borderColor: Color = AdminListDefaults.Border,
    iconTint: Color = AdminListDefaults.Muted,
    textColor: Color = AdminListDefaults.Navy,
    cursorColor: Color = AdminListDefaults.Primary
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isFocused by interactionSource.collectIsFocusedAsState()
    Surface(
        modifier = modifier.size(width = width, height = height),
        shape = androidx.compose.foundation.shape.RoundedCornerShape(6.dp),
        color = surfaceColor,
        border = androidx.compose.foundation.BorderStroke(1.dp, if (isFocused) AdminListDefaults.Primary else borderColor)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .height(height)
                .padding(horizontal = 12.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            Icon(
                painter = painterResource(Res.drawable.search),
                contentDescription = "Search",
                tint = iconTint,
                modifier = Modifier.size(16.dp)
            )
            BasicTextField(
                value = value,
                onValueChange = onValueChange,
                singleLine = true,
                interactionSource = interactionSource,
                textStyle = TextStyle(
                    fontSize = AdminListTypography.Control,
                    fontWeight = AdminListTypography.ControlWeight,
                    color = textColor
                ),
                cursorBrush = SolidColor(cursorColor),
                modifier = Modifier.weight(1f)
            ) { innerTextField ->
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.CenterStart
                ) {
                    if (value.isBlank()) {
                        Text(
                            text = placeholder,
                            color = iconTint,
                            fontSize = AdminListTypography.Control,
                            fontWeight = AdminListTypography.ControlWeight,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                    innerTextField()
                }
            }
        }
    }
}

@Composable
fun AdminListToolbarButton(
    label: String,
    icon: Painter,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    width: Dp = 116.dp,
    height: Dp = 40.dp,
    surfaceColor: Color = AdminListDefaults.Surface,
    borderColor: Color = AdminListDefaults.Border,
    contentColor: Color = AdminListDefaults.Primary,
    iconSize: Dp = 16.dp
) {
    val displayLabel = when (label.lowercase()) {
        "filter", "filters", "more filters" -> "More Filters"
        else -> label
    }
    val iconOnly = label.equals("Refresh", ignoreCase = true)
    val activeFilterHost = LocalAdminListActiveFilterHost.current
    val resolvedWidth = when {
        iconOnly -> 40.dp
        displayLabel == "More Filters" -> maxOf(width, 144.dp)
        else -> width
    }
    Row(
        modifier = modifier
            .size(width = resolvedWidth, height = height)
            .background(surfaceColor, androidx.compose.foundation.shape.RoundedCornerShape(6.dp))
            .border(1.dp, borderColor, androidx.compose.foundation.shape.RoundedCornerShape(6.dp))
            .clickable {
                // Reset/Clear must drop toolbar chip host state so More Filters chips
                // disappear even when the banner slot is not recomposed immediately.
                if (label.equals("Clear", ignoreCase = true) ||
                    label.equals("Reset", ignoreCase = true)
                ) {
                    activeFilterHost?.let { host ->
                        host.chips = emptyList()
                        host.onClearAll = null
                        host.onRemoveChip = null
                    }
                }
                onClick()
            }
            .padding(horizontal = if (iconOnly) 0.dp else 16.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    ) {
        Icon(
            painter = icon,
            contentDescription = displayLabel,
            tint = contentColor,
            modifier = Modifier.size(iconSize)
        )
        if (!iconOnly) {
            Spacer(modifier = Modifier.width(8.dp))
            Text(
                text = displayLabel,
                style = MaterialTheme.typography.labelLarge.copy(fontSize = AdminListTypography.Control),
                color = contentColor,
                fontWeight = AdminListTypography.ControlWeightStrong,
                maxLines = 1,
                softWrap = false
            )
        }
    }
}

@Composable
fun AdminListTableCard(
    modifier: Modifier = Modifier,
    surfaceColor: Color = AdminListDefaults.Surface,
    borderColor: Color = AdminListDefaults.Border,
    shape: androidx.compose.ui.graphics.Shape = AdminListDefaults.CornerShape,
    minContentWidth: Dp = 960.dp,
    showVerticalScrollbar: Boolean = true,
    header: @Composable () -> Unit,
    body: @Composable ColumnScope.() -> Unit,
    footer: @Composable () -> Unit
) {
    val horizontalScrollState = rememberScrollState()
    val verticalScrollbarHost = remember { AdminListVerticalScrollbarHost() }
    Card(
        modifier = modifier,
        shape = shape,
        colors = CardDefaults.cardColors(containerColor = surfaceColor),
        border = androidx.compose.foundation.BorderStroke(1.dp, borderColor)
    ) {
        Column(modifier = Modifier.fillMaxSize()) {
            // Keep the header and body in the same horizontally scrollable
            // content surface so weighted columns stay aligned on compact
            // windows, just like an HTML table inside overflow-x: auto.
            BoxWithConstraints(
                modifier = Modifier
                    .weight(1f)
                    .fillMaxWidth()
            ) {
                val contentWidth = maxOf(maxWidth, minContentWidth)
                Column(
                    modifier = Modifier.fillMaxSize()
                ) {
                    Box(
                        modifier = Modifier
                            .weight(1f)
                            .fillMaxSize()
                    ) {
                        Box(
                            modifier = Modifier
                                .fillMaxSize()
                                .horizontalScroll(horizontalScrollState)
                        ) {
                            Column(
                                modifier = Modifier
                                    .width(contentWidth)
                                    .fillMaxHeight()
                            ) {
                                header()
                                HorizontalDivider(color = borderColor)
                                Column(
                                    modifier = Modifier
                                        .weight(1f)
                                        .fillMaxWidth()
                                ) {
                                    CompositionLocalProvider(LocalAdminListVerticalScrollbarHost provides verticalScrollbarHost) {
                                        body()
                                    }
                                }
                            }
                        }
                        if (showVerticalScrollbar && isDesktopScrollablePlatform()) {
                            verticalScrollbarHost.state?.let { state ->
                                DesktopLazyScrollbarOverlay(
                                    state = state,
                                    modifier = Modifier.align(Alignment.CenterEnd)
                                )
                            }
                        }
                    }
                    AdminListHorizontalScrollbar(
                        state = horizontalScrollState,
                        modifier = Modifier.fillMaxWidth()
                    )
                }
            }
            HorizontalDivider(color = borderColor)
            footer()
        }
    }
}

/**
 * Standard vertically scrollable body for admin list/table pages.
 *
 * Keep table headers, rows and footers feature-owned, but use this body for
 * consistent constrained scrolling and the shared desktop scrollbar.
 */
@Composable
fun <T> AdminListTableBody(
    items: List<T>,
    key: (T) -> Any,
    modifier: Modifier = Modifier.fillMaxWidth(),
    verticalArrangement: Arrangement.Vertical = Arrangement.spacedBy(0.dp),
    selectedKey: Any? = null,
    onRowSelected: ((T) -> Unit)? = null,
    itemContent: @Composable (T) -> Unit
) {
    val scrollbarHost = LocalAdminListVerticalScrollbarHost.current
    val state = rememberLazyListState()
    DisposableEffect(scrollbarHost, state) {
        scrollbarHost?.state = state
        onDispose {
            if (scrollbarHost?.state === state) scrollbarHost.state = null
        }
    }

    DesktopAwareLazyColumn(
        modifier = modifier,
        state = state,
        verticalArrangement = verticalArrangement
    ) {
        itemsIndexed(items = items, key = { _, item -> key(item) }) { _, item ->
            val itemKey = key(item)
            val isSelected = selectedKey != null && selectedKey == itemKey
            val interactionSource = remember { MutableInteractionSource() }
            val isHovered by interactionSource.collectIsHoveredAsState()
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .defaultMinSize(minHeight = 52.dp)
                    .background(
                        when {
                            isSelected -> AdminListDefaults.SelectedRow
                            isHovered -> AdminListDefaults.HoverRow
                            else -> AdminListDefaults.Surface
                        }
                    )
                    .hoverable(interactionSource)
                    .then(
                        onRowSelected?.let { onSelect ->
                            Modifier.selectable(
                                selected = isSelected,
                                interactionSource = interactionSource,
                                role = Role.Button,
                                onClick = { onSelect(item) }
                            )
                        } ?: Modifier
                    )
            ) {
                itemContent(item)
            }
        }
    }
}

private const val ADMIN_SCROLLBAR_MIN_THUMB_DP = 28f
private const val ADMIN_SCROLLBAR_HEIGHT_DP = 18f
private const val ADMIN_SCROLLBAR_THUMB_HEIGHT_DP = 6f
private const val ADMIN_SCROLLBAR_TOUCH_HEIGHT_DP = 18f

/**
 * A browser-like horizontal scrollbar for horizontally overflowing tables.
 * It stays visible whenever the content overflows and supports thumb dragging.
 */
@Composable
internal fun AdminListHorizontalScrollbar(
    state: androidx.compose.foundation.ScrollState,
    modifier: Modifier = Modifier
) {
    val density = LocalDensity.current
    val minThumbPx = with(density) { ADMIN_SCROLLBAR_MIN_THUMB_DP.dp.toPx() }
    val thumbHeightPx = with(density) { ADMIN_SCROLLBAR_THUMB_HEIGHT_DP.dp.toPx() }
    val metrics by remember(state) {
        derivedStateOf { state.maxValue > 0 }
    }
    var dragGrabOffsetPx by remember { mutableStateOf(0f) }

    if (!metrics) return

    Box(
        modifier = modifier
            .fillMaxWidth()
            .height(ADMIN_SCROLLBAR_HEIGHT_DP.dp)
            .pointerInput(state) {
                detectDragGestures(
                    onDragStart = { offset ->
                        if (!metrics || size.width <= 0) return@detectDragGestures
                        val viewport = size.width.toFloat()
                        val content = viewport + state.maxValue
                        val thumbWidth = (viewport * viewport / content).coerceIn(minThumbPx, viewport)
                        val thumbLeft = (viewport - thumbWidth) * state.value / state.maxValue.coerceAtLeast(1)
                        dragGrabOffsetPx = (offset.x - thumbLeft).coerceIn(0f, thumbWidth)
                    },
                    onDrag = { change, dragAmount ->
                        change.consume()
                        if (!metrics || size.width <= 0) return@detectDragGestures
                        val viewport = size.width.toFloat()
                        val content = viewport + state.maxValue
                        val thumbWidth = (viewport * viewport / content).coerceIn(minThumbPx, viewport)
                        val maxLeft = (viewport - thumbWidth).coerceAtLeast(1f)
                        // Apply the pointer delta directly, like a browser scrollbar.
                        // Launching/cancelling a scroll job for every pointer event makes
                        // the thumb and table appear to jump under fast dragging.
                        state.dispatchRawDelta(dragAmount.x * state.maxValue / maxLeft)
                    },
                    onDragEnd = { dragGrabOffsetPx = 0f },
                    onDragCancel = { dragGrabOffsetPx = 0f }
                )
            }
            .drawWithContent {
                if (!metrics || size.width <= 0f) return@drawWithContent
                val viewport = size.width
                val content = viewport + state.maxValue
                val thumbWidth = (viewport * viewport / content).coerceIn(minThumbPx, viewport)
                val maxLeft = (viewport - thumbWidth).coerceAtLeast(0f)
                val thumbLeft = if (state.maxValue == 0) 0f else maxLeft * state.value / state.maxValue
                drawRoundRect(
                    color = Color(0xFFF1F1F1),
                    topLeft = Offset(0f, (size.height - thumbHeightPx) / 2f),
                    size = Size(viewport, thumbHeightPx),
                    cornerRadius = CornerRadius(thumbHeightPx / 2f)
                )
                drawRoundRect(
                    color = Color(0xFF7A7A7A).copy(alpha = 0.9f),
                    topLeft = Offset(thumbLeft, (size.height - thumbHeightPx) / 2f),
                    size = Size(thumbWidth, thumbHeightPx),
                    cornerRadius = CornerRadius(thumbHeightPx / 2f)
                )
            }
    )
}

@Composable
fun AdminListTableShimmer(
    columns: List<AdminListHeaderColumn>,
    rowCount: Int = 6,
    modifier: Modifier = Modifier,
    rowHeight: Dp = 52.dp,
    surfaceColor: Color = AdminListDefaults.Surface,
    borderColor: Color = AdminListDefaults.Border,
    horizontalPadding: Dp = 24.dp,
    verticalPadding: Dp = 4.dp,
    cellHorizontalPadding: Dp = 0.dp
) {
    val transition = rememberInfiniteTransition(label = "admin_list_table_shimmer")
    val shimmerX by transition.animateFloat(
        initialValue = -400f,
        targetValue = 1400f,
        animationSpec = infiniteRepeatable(
            animation = tween(durationMillis = 1200),
            repeatMode = RepeatMode.Restart
        ),
        label = "admin_list_table_shimmer_x"
    )
    val shimmerBrush = androidx.compose.ui.graphics.Brush.linearGradient(
        colors = listOf(
            Color(0xFFE4EAF7),
            Color(0xFFF9FBFF),
            Color(0xFFE4EAF7)
        ),
        start = Offset(shimmerX, shimmerX),
        end = Offset(shimmerX + 240f, shimmerX + 240f)
    )

    Column(
        modifier = modifier
            .fillMaxSize()
            .background(surfaceColor)
    ) {
        repeat(rowCount.coerceAtLeast(1)) { rowIndex ->
            if (rowIndex > 0) {
                HorizontalDivider(color = borderColor)
            }
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(rowHeight)
                    .padding(horizontal = horizontalPadding, vertical = verticalPadding),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(0.dp)
            ) {
                columns.forEachIndexed { columnIndex, column ->
                    val cellModifier = Modifier
                        .weight(column.weight)
                        .fillMaxHeight()
                    Box(
                        modifier = cellModifier,
                        contentAlignment = when {
                            column.alignCenter -> Alignment.Center
                            column.alignEnd -> Alignment.CenterEnd
                            else -> Alignment.CenterStart
                        }
                    ) {
                        val isActionColumn = columnIndex == columns.lastIndex &&
                            (column.label.equals("Actions", ignoreCase = true) || column.weight <= 0.7f)
                        val cellWidth = when {
                            isActionColumn -> 20.dp
                            column.weight >= 1.5f -> 76.dp
                            column.weight >= 1.0f -> 64.dp
                            else -> 54.dp
                        }
                        val cellHeight = if (isActionColumn) 20.dp else 14.dp
                        Box(
                            modifier = Modifier
                                .padding(horizontal = cellHorizontalPadding)
                                .width(cellWidth)
                                .height(cellHeight)
                                .clip(if (isActionColumn) AdminListDefaults.CircleShape else AdminListDefaults.CornerShape)
                                .background(shimmerBrush)
                        )
                    }
                }
            }
        }
    }
}

/** Shared loading placeholder for pages whose summary cards load independently of the table. */
@Composable
fun RowScope.AdminListSummaryCardsShimmer(
    cardCount: Int = 4,
    cardHeight: Dp = 108.dp,
    cardShape: androidx.compose.ui.graphics.Shape = androidx.compose.foundation.shape.RoundedCornerShape(14.dp),
    contentPadding: PaddingValues = PaddingValues(16.dp),
    iconSize: Dp = 46.dp,
    horizontalSpacing: Dp = 12.dp,
    titleWidth: Dp = 96.dp,
    titleHeight: Dp = 13.dp,
    valueWidth: Dp = 62.dp,
    valueHeight: Dp = 25.dp,
    subtitleWidth: Dp = 118.dp,
    subtitleHeight: Dp = 11.dp
) {
    val transition = rememberInfiniteTransition(label = "admin_summary_cards_shimmer")
    val shimmerX by transition.animateFloat(
        initialValue = -360f,
        targetValue = 1200f,
        animationSpec = infiniteRepeatable(tween(1200), RepeatMode.Restart),
        label = "admin_summary_cards_shimmer_x"
    )
    val shimmerBrush = androidx.compose.ui.graphics.Brush.linearGradient(
        colors = listOf(Color(0xFFE4EAF7), Color(0xFFF9FBFF), Color(0xFFE4EAF7)),
        start = Offset(shimmerX, shimmerX),
        end = Offset(shimmerX + 240f, shimmerX + 240f)
    )
    repeat(cardCount.coerceAtLeast(1)) {
        Card(
            modifier = Modifier.weight(1f).height(cardHeight),
            shape = cardShape,
            colors = CardDefaults.cardColors(containerColor = Color.White),
            elevation = CardDefaults.cardElevation(defaultElevation = 0.dp)
        ) {
            Row(
                modifier = Modifier.fillMaxSize().padding(contentPadding),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(horizontalSpacing)
            ) {
                Box(Modifier.size(iconSize).background(shimmerBrush, androidx.compose.foundation.shape.RoundedCornerShape(12.dp)))
                Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                    Box(Modifier.width(titleWidth).height(titleHeight).background(shimmerBrush, androidx.compose.foundation.shape.RoundedCornerShape(8.dp)))
                    Box(Modifier.width(valueWidth).height(valueHeight).background(shimmerBrush, androidx.compose.foundation.shape.RoundedCornerShape(8.dp)))
                    Box(Modifier.width(subtitleWidth).height(subtitleHeight).background(shimmerBrush, androidx.compose.foundation.shape.RoundedCornerShape(8.dp)))
                }
            }
        }
    }
}

@Composable
fun AdminListScrollableTableCard(
    minContentWidth: Dp,
    modifier: Modifier = Modifier,
    surfaceColor: Color = AdminListDefaults.Surface,
    borderColor: Color = AdminListDefaults.Border,
    shape: androidx.compose.ui.graphics.Shape = AdminListDefaults.CornerShape,
    header: @Composable () -> Unit,
    body: @Composable ColumnScope.() -> Unit,
    footer: @Composable () -> Unit
) {
    val horizontalScrollState = rememberScrollState()
    Card(
        modifier = modifier,
        shape = shape,
        colors = CardDefaults.cardColors(containerColor = surfaceColor),
        border = androidx.compose.foundation.BorderStroke(1.dp, borderColor)
    ) {
        Column(modifier = Modifier.fillMaxSize()) {
            BoxWithConstraints(
                modifier = Modifier
                    .weight(1f)
                    .fillMaxWidth()
            ) {
                val contentWidth = maxOf(maxWidth, minContentWidth)
                Column(
                    modifier = Modifier.fillMaxSize()
                ) {
                    Box(
                        modifier = Modifier
                            .weight(1f)
                            .fillMaxWidth()
                            .horizontalScroll(horizontalScrollState)
                    ) {
                        Column(
                            modifier = Modifier
                                .width(contentWidth)
                                .fillMaxHeight()
                        ) {
                            header()
                            HorizontalDivider(color = borderColor)
                            Column(
                                modifier = Modifier
                                    .weight(1f)
                                    .fillMaxWidth()
                            ) {
                                body()
                            }
                        }
                    }
                    AdminListHorizontalScrollbar(
                        state = horizontalScrollState,
                        modifier = Modifier.fillMaxWidth()
                    )
                }
            }
            HorizontalDivider(color = borderColor)
            footer()
        }
    }
}

@Composable
fun AdminListEmptyState(
    title: String,
    subtitle: String? = null,
    titleColor: Color = AdminListDefaults.Navy,
    subtitleColor: Color = AdminListDefaults.Muted
) {
    Column(horizontalAlignment = Alignment.CenterHorizontally) {
        Text(
            text = title,
            color = titleColor,
            fontSize = 16.sp,
            fontWeight = FontWeight.SemiBold
        )
        if (!subtitle.isNullOrBlank()) {
            Spacer(modifier = Modifier.height(6.dp))
            Text(
                text = subtitle,
                color = subtitleColor,
                fontSize = 14.sp,
                fontWeight = FontWeight.Normal
            )
        }
    }
}

@Composable
fun AdminInfoBanner(
    message: String,
    onDismiss: () -> Unit,
    modifier: Modifier = Modifier,
    leadingIcon: Painter? = null,
    backgroundColor: Color = Color(0xFFF2F7FF),
    borderColor: Color = Color(0xFFD9E7FF),
    contentColor: Color = AdminListDefaults.Navy,
    accentColor: Color = AdminListDefaults.Primary,
    dismissLabel: String? = "Dismiss",
    isError: Boolean = false
) {
    if (message.isBlank()) return
    if (isError) {
        LaunchedEffect(message) {
            AppErrorCenter.emit(message, source = "AdminInfoBanner")
        }
        return
    }
    if (isSuccessMessage(message)) {
        LaunchedEffect(message) {
            AppToastCenter.showSuccess(message)
        }
        return
    }

    Surface(
        modifier = modifier.fillMaxWidth(),
        color = backgroundColor,
        shape = AdminListDefaults.CornerShape,
        border = androidx.compose.foundation.BorderStroke(1.dp, borderColor)
    ) {
        Row(
            modifier = Modifier.padding(horizontal = 16.dp, vertical = 12.dp),
            horizontalArrangement = Arrangement.spacedBy(12.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (leadingIcon != null) {
                Icon(
                    painter = leadingIcon,
                    contentDescription = null,
                    tint = accentColor,
                    modifier = Modifier.size(16.dp)
                )
            }
            Text(
                text = message,
                modifier = Modifier.weight(1f),
                color = contentColor,
                fontSize = 14.sp,
                fontWeight = FontWeight.Normal
            )
            if (!dismissLabel.isNullOrBlank()) {
                Text(
                    text = dismissLabel,
                    color = accentColor,
                    fontSize = 12.sp,
                    fontWeight = FontWeight.SemiBold,
                    modifier = Modifier.clickable(onClick = onDismiss)
                )
            }
        }
    }

    /*
    Surface(
        modifier = modifier.fillMaxWidth(),
        color = backgroundColor,
        shape = AdminListDefaults.CornerShape,
        border = androidx.compose.foundation.BorderStroke(1.dp, borderColor)
    ) {
        Row(
            modifier = Modifier.padding(horizontal = 16.dp, vertical = 12.dp),
            horizontalArrangement = Arrangement.spacedBy(12.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (leadingIcon != null) {
                Box(
                    modifier = Modifier
                        .size(24.dp)
                        .background(accentColor.copy(alpha = 0.12f), AdminListDefaults.CornerShape),
                    contentAlignment = Alignment.Center
                ) {
                    androidx.compose.material3.Icon(
                        painter = leadingIcon,
                        contentDescription = null,
                        tint = accentColor,
                        modifier = Modifier.size(14.dp)
                    )
                }
            }
            Text(
                text = message,
                modifier = Modifier.weight(1f),
                color = contentColor,
                style = MaterialTheme.typography.bodyMedium
            )
            if (!dismissLabel.isNullOrBlank()) {
                Text(
                    text = dismissLabel,
                    color = accentColor,
                    style = MaterialTheme.typography.bodyMedium,
                    fontWeight = FontWeight.ExtraBold,
                    modifier = Modifier.clickable(onClick = onDismiss)
                )
            }
        }
    }
    */
}

private fun isSuccessMessage(message: String): Boolean {
    val normalized = message.trim().lowercase()
    return listOf(
        "added ", "created ", "deleted ", "downloaded ", "published ",
        "removed ", "saved ", "sent ", "updated ", "verified successfully",
        "activated ", "deactivated ", "restored "
    ).any(normalized::startsWith)
}

/** Standard message and active-filter layout for paginated admin lists. */
@Composable
fun AdminListMessageAndFilters(
    message: String,
    onDismissMessage: () -> Unit,
    chips: List<String>,
    onClearAll: () -> Unit,
    onRemoveChip: ((String) -> Unit)? = null,
    modifier: Modifier = Modifier,
    isError: Boolean = false,
    onEditFilters: (() -> Unit)? = null,
    messageBackgroundColor: Color? = null,
    messageBorderColor: Color? = null,
    messageContentColor: Color? = null,
    messageAccentColor: Color? = null,
    filterBackgroundColor: Color? = null,
    filterBorderColor: Color? = null,
    filterContentColor: Color? = null,
    filterAccentColor: Color? = null,
    messageLeadingIcon: Painter? = null
) {
    if (LocalAdminListActiveFilterHost.current != null) {
        AdminListFilterBanner(
            chips = chips,
            onClearAll = onClearAll,
            onRemoveChip = onRemoveChip,
            onEditFilters = onEditFilters,
            backgroundColor = filterBackgroundColor ?: Color(0xFFF2F7FF),
            borderColor = filterBorderColor ?: Color(0xFFD9E7FF),
            contentColor = filterContentColor ?: AdminListDefaults.Navy,
            accentColor = filterAccentColor ?: AdminListDefaults.Primary
        )
        if (message.isBlank()) return
        AdminInfoBanner(
            message = message,
            onDismiss = onDismissMessage,
            modifier = modifier,
            backgroundColor = messageBackgroundColor
                ?: if (isError) Color(0xFFFFF2F2) else Color(0xFFF2F7FF),
            borderColor = messageBorderColor
                ?: if (isError) Color(0xFFFFD5D5) else Color(0xFFD9E7FF),
            contentColor = messageContentColor
                ?: if (isError) Color(0xFF9B1C1C) else AdminListDefaults.Navy,
            accentColor = messageAccentColor
                ?: if (isError) Color(0xFFDC2626) else AdminListDefaults.Primary,
            leadingIcon = messageLeadingIcon,
            isError = isError
        )
        return
    }
    if (message.isBlank() && chips.isEmpty()) return

    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        if (message.isNotBlank()) {
            AdminInfoBanner(
                message = message,
                onDismiss = onDismissMessage,
                backgroundColor = messageBackgroundColor
                    ?: if (isError) Color(0xFFFFF2F2) else Color(0xFFF2F7FF),
                borderColor = messageBorderColor
                    ?: if (isError) Color(0xFFFFD5D5) else Color(0xFFD9E7FF),
                contentColor = messageContentColor
                    ?: if (isError) Color(0xFF9B1C1C) else AdminListDefaults.Navy,
                accentColor = messageAccentColor
                    ?: if (isError) Color(0xFFDC2626) else AdminListDefaults.Primary,
                leadingIcon = messageLeadingIcon,
                isError = isError
            )
        }
        AdminListFilterBanner(
            chips = chips,
            onClearAll = onClearAll,
            onRemoveChip = onRemoveChip,
            onEditFilters = onEditFilters,
            backgroundColor = filterBackgroundColor ?: Color(0xFFF2F7FF),
            borderColor = filterBorderColor ?: Color(0xFFD9E7FF),
            contentColor = filterContentColor ?: AdminListDefaults.Navy,
            accentColor = filterAccentColor ?: AdminListDefaults.Primary
        )
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun AdminListFilterBanner(
    chips: List<String>,
    onClearAll: () -> Unit,
    modifier: Modifier = Modifier,
    title: String = "Filters active",
    subtitle: String = "These filters are narrowing the current list.",
    onEditFilters: (() -> Unit)? = null,
    editLabel: String = "Edit filters",
    clearLabel: String = "Clear all",
    onRemoveChip: ((String) -> Unit)? = null,
    backgroundColor: Color = Color(0xFFF2F7FF),
    borderColor: Color = Color(0xFFD9E7FF),
    contentColor: Color = AdminListDefaults.Navy,
    accentColor: Color = AdminListDefaults.Primary,
    leadingIcon: Painter? = null
) {
    LocalAdminListActiveFilterHost.current?.let { host ->
        if (chips.isEmpty()) {
            host.chips = emptyList()
            host.onClearAll = null
            host.onRemoveChip = null
            return
        }
        host.chips = chips
        host.onClearAll = onClearAll
        host.onRemoveChip = onRemoveChip
        host.backgroundColor = backgroundColor
        host.contentColor = contentColor
        host.accentColor = accentColor
        return
    }

    if (chips.isEmpty()) return

    Surface(
        modifier = modifier.fillMaxWidth(),
        color = backgroundColor,
        shape = AdminListDefaults.CornerShape,
        border = androidx.compose.foundation.BorderStroke(1.dp, borderColor)
    ) {
        Column(
            modifier = Modifier.padding(horizontal = 16.dp, vertical = 14.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(12.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                if (leadingIcon != null) {
                    Box(
                        modifier = Modifier
                            .size(34.dp)
                            .background(accentColor.copy(alpha = 0.12f), AdminListDefaults.CornerShape),
                        contentAlignment = Alignment.Center
                    ) {
                        Icon(
                            painter = leadingIcon,
                            contentDescription = null,
                            tint = accentColor,
                            modifier = Modifier.size(18.dp)
                        )
                    }
                }
                Column(
                    modifier = Modifier.weight(1f),
                    verticalArrangement = Arrangement.spacedBy(2.dp)
                ) {
                    Text(
                        text = title,
                        color = contentColor,
                        style = MaterialTheme.typography.bodyMedium,
                        fontWeight = FontWeight.ExtraBold
                    )
                    Text(
                        text = subtitle,
                        color = contentColor.copy(alpha = 0.78f),
                        style = MaterialTheme.typography.bodySmall
                    )
                }
                if (onEditFilters != null) {
                    OutlinedButton(
                        onClick = onEditFilters,
                        contentPadding = PaddingValues(horizontal = 14.dp, vertical = 8.dp),
                        shape = AdminListDefaults.CornerShape
                    ) {
                        Text(
                            text = editLabel,
                            fontWeight = FontWeight.Bold
                        )
                    }
                }
                Text(
                    text = clearLabel,
                    color = accentColor,
                    style = MaterialTheme.typography.bodyMedium,
                    fontWeight = FontWeight.ExtraBold,
                    modifier = Modifier.clickable(onClick = onClearAll)
                )
            }

            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                chips.forEach { chip ->
                    Surface(
                        color = Color.White,
                        shape = AdminListDefaults.CircleShape,
                        border = androidx.compose.foundation.BorderStroke(1.dp, accentColor.copy(alpha = 0.18f))
                    ) {
                        Row(
                            modifier = Modifier.padding(horizontal = 12.dp, vertical = 7.dp),
                            horizontalArrangement = Arrangement.spacedBy(6.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Box(
                                modifier = Modifier
                                    .size(7.dp)
                                    .background(accentColor, AdminListDefaults.CircleShape)
                            )
                            Text(
                                text = chip,
                                color = contentColor,
                                style = MaterialTheme.typography.bodySmall,
                                fontWeight = FontWeight.SemiBold
                            )
                            if (onRemoveChip != null) {
                                IconButton(
                                    onClick = { onRemoveChip(chip) },
                                    modifier = Modifier.size(22.dp)
                                ) {
                                    Icon(
                                        painter = painterResource(Res.drawable.close_x),
                                        contentDescription = "Remove $chip filter",
                                        tint = contentColor.copy(alpha = 0.72f),
                                        modifier = Modifier.size(13.dp)
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun AdminStatusChip(
    label: String,
    contentColor: Color,
    backgroundColor: Color,
    modifier: Modifier = Modifier,
    dotColor: Color? = null
) {
    Text(
        text = label,
        modifier = modifier,
        color = contentColor,
        fontSize = AdminListTypography.TableBody,
        fontWeight = AdminListTypography.TableBodyWeight
    )
}

@Composable
fun AdminRowActionMenu(
    sections: List<List<AdminRowActionItem>>,
    onDismissRequest: () -> Unit,
    modifier: Modifier = Modifier,
    expanded: Boolean = true,
    width: Dp = 190.dp,
    surfaceColor: Color = AdminListDefaults.Surface,
    borderColor: Color = AdminListDefaults.Border,
    tonalElevation: Dp = 0.dp,
    shadowElevation: Dp = 12.dp
) {
    AppDropdownMenu(
        expanded = expanded,
        onDismissRequest = onDismissRequest,
        modifier = modifier.width(width),
        containerColor = surfaceColor,
        tonalElevation = tonalElevation,
        shadowElevation = shadowElevation,
        border = androidx.compose.foundation.BorderStroke(1.dp, borderColor)
    ) {
        sections.forEach { section ->
            section.forEach { item ->
                AdminListActionMenuItem(
                    label = item.label,
                    onClick = item.onClick,
                    icon = item.icon,
                    iconTint = item.iconTint ?: AdminListDefaults.Navy,
                    labelColor = item.labelColor ?: AdminListDefaults.Navy
                )
            }
        }
    }
}

@Composable
fun AdminStandardRowActionMenu(
    isActive: Boolean,
    onDismissRequest: () -> Unit,
    onView: () -> Unit,
    onEdit: () -> Unit,
    onToggleStatus: (() -> Unit)? = null,
    onDelete: () -> Unit,
    toggleStatusLabel: String? = null,
    modifier: Modifier = Modifier,
    expanded: Boolean = true,
    width: Dp = 190.dp,
    surfaceColor: Color = AdminListDefaults.Surface,
    borderColor: Color = AdminListDefaults.Border,
    tonalElevation: Dp = 0.dp,
    shadowElevation: Dp = 12.dp,
    showViewEditActions: Boolean = true
) {
    val activateColor = Color(0xFF16A34A)
    val inactivateColor = Color(0xFFDC2626)
    AdminRowActionMenu(
        sections = listOf(
            listOfNotNull(
                if (showViewEditActions) AdminRowActionItem(
                    label = "View",
                    onClick = onView,
                    icon = painterResource(Res.drawable.eye),
                    iconTint = AdminListDefaults.Primary
                ) else null,
                if (showViewEditActions) AdminRowActionItem(
                    label = "Edit",
                    onClick = onEdit,
                    icon = painterResource(Res.drawable.pencil),
                    iconTint = AdminListDefaults.Primary
                ) else null,
                onToggleStatus?.let {
                    AdminRowActionItem(
                        label = toggleStatusLabel ?: if (isActive) "Inactivate" else "Activate",
                        onClick = it,
                        icon = painterResource(if (isActive) Res.drawable.ban else Res.drawable.circle_check),
                        iconTint = if (isActive) inactivateColor else activateColor,
                        labelColor = if (isActive) inactivateColor else activateColor
                    )
                }
            ),
            listOf(
                AdminRowActionItem(
                    label = "Delete",
                    onClick = onDelete,
                    icon = painterResource(Res.drawable.trash),
                    iconTint = inactivateColor,
                    labelColor = inactivateColor
                )
            )
        ),
        onDismissRequest = onDismissRequest,
        modifier = modifier,
        expanded = expanded,
        width = width,
        surfaceColor = surfaceColor,
        borderColor = borderColor,
        tonalElevation = tonalElevation,
        shadowElevation = shadowElevation
    )
}

@Composable
fun AdminListRowActionBar(
    isActive: Boolean,
    expanded: Boolean,
    onExpandedChange: (Boolean) -> Unit,
    onDismissRequest: () -> Unit,
    onView: () -> Unit,
    onEdit: () -> Unit,
    onToggleStatus: (() -> Unit)? = null,
    onDelete: () -> Unit,
    toggleStatusLabel: String? = null,
    modifier: Modifier = Modifier,
    width: Dp = 190.dp,
    surfaceColor: Color = AdminListDefaults.Surface,
    borderColor: Color = AdminListDefaults.Border
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(2.dp)
    ) {
        IconButton(onClick = onView, modifier = Modifier.size(32.dp)) {
            Icon(painterResource(Res.drawable.eye), "View", tint = AdminListDefaults.Navy, modifier = Modifier.size(16.dp))
        }
        IconButton(onClick = onEdit, modifier = Modifier.size(32.dp)) {
            Icon(painterResource(Res.drawable.pencil), "Edit", tint = AdminListDefaults.Navy, modifier = Modifier.size(16.dp))
        }
        Box {
            IconButton(onClick = { onExpandedChange(!expanded) }, modifier = Modifier.size(32.dp)) {
                Icon(painterResource(Res.drawable.more_vertical), "More actions", tint = AdminListDefaults.Navy, modifier = Modifier.size(16.dp))
            }
            AdminStandardRowActionMenu(
                isActive = isActive,
                expanded = expanded,
                onDismissRequest = onDismissRequest,
                onView = onView,
                onEdit = onEdit,
                onToggleStatus = onToggleStatus,
                onDelete = onDelete,
                toggleStatusLabel = toggleStatusLabel,
                width = width,
                surfaceColor = surfaceColor,
                borderColor = borderColor,
                showViewEditActions = false
            )
        }
    }
}

@Composable
fun AdminListViewActionButton(
    onClick: () -> Unit,
    contentDescription: String = "View",
    modifier: Modifier = Modifier
) {
    IconButton(onClick = onClick, modifier = modifier.size(32.dp)) {
        Icon(
            painterResource(Res.drawable.eye),
            contentDescription,
            tint = AdminListDefaults.Navy,
            modifier = Modifier.size(16.dp)
        )
    }
}

@Composable
fun AdminListActionIcons(
    onView: (() -> Unit)? = null,
    onEdit: (() -> Unit)? = null,
    editEnabled: Boolean = true,
    editDisabledDescription: String = "Edit unavailable for expired announcement",
    modifier: Modifier = Modifier,
    moreActions: @Composable BoxScope.() -> Unit
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(2.dp)
    ) {
        onView?.let { onClick ->
            IconButton(onClick = onClick, modifier = Modifier.size(32.dp)) {
                Icon(painterResource(Res.drawable.eye), "View", tint = AdminListDefaults.Navy, modifier = Modifier.size(16.dp))
            }
        }
        onEdit?.let { onClick ->
            IconButton(onClick = onClick, enabled = editEnabled, modifier = Modifier.size(32.dp)) {
                Icon(
                    painterResource(Res.drawable.pencil),
                    if (editEnabled) "Edit" else editDisabledDescription,
                    tint = if (editEnabled) AdminListDefaults.Navy else AdminListDefaults.Muted,
                    modifier = Modifier.size(16.dp)
                )
            }
        }
        Box(content = moreActions)
    }
}

@Composable
fun AdminListSortHeaderRow(
    columns: List<AdminListSortColumn>,
    actionsLabel: String = "Actions",
    actionsWeight: Float = 0.95f,
    actionsSortable: Boolean = false,
    modifier: Modifier = Modifier,
    height: Dp = 44.dp,
    horizontalPadding: Dp = 24.dp,
    labelColor: Color = AdminListDefaults.Navy,
    selectedColor: Color = AdminListDefaults.Primary,
    unselectedColor: Color = AdminListDefaults.Muted,
    actionsAlignment: Alignment = Alignment.Center
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .height(height)
            .background(AdminListDefaults.HeaderBackground)
            .padding(horizontal = horizontalPadding),
        verticalAlignment = Alignment.CenterVertically
    ) {
        columns.forEach { column ->
            AdminListSortHeaderCell(
                label = column.label,
                weight = column.weight,
                selected = column.selected,
                ascending = column.ascending,
                onClick = column.onClick,
                sortable = column.sortable,
                alignCenter = column.alignCenter,
                labelColor = labelColor,
                selectedColor = selectedColor,
                unselectedColor = unselectedColor
            )
        }
        Box(
            modifier = Modifier.weight(actionsWeight),
            contentAlignment = actionsAlignment
        ) {
            if (actionsSortable) AdminListSortLabel(actionsLabel, false, true, labelColor, selectedColor, unselectedColor)
            else Text(actionsLabel, color = labelColor, style = MaterialTheme.typography.labelLarge.copy(fontSize = AdminListTypography.TableHeader), fontWeight = AdminListTypography.TableHeaderWeight)
        }
    }
}

@Composable
fun AdminListHeaderRow(
    columns: List<AdminListHeaderColumn>,
    modifier: Modifier = Modifier,
    height: Dp = 44.dp,
    horizontalPadding: Dp = 24.dp,
    labelColor: Color = AdminListDefaults.Navy
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .height(height)
            .background(AdminListDefaults.HeaderBackground)
            .padding(horizontal = horizontalPadding),
        verticalAlignment = Alignment.CenterVertically
    ) {
        columns.forEach { column ->
            AdminListHeaderCell(
                column = column,
                labelColor = labelColor
            )
        }
    }
}

@Composable
fun AdminListSpreadsheetHeaderRow(
    columns: List<AdminListHeaderColumn>,
    modifier: Modifier = Modifier,
    height: Dp = 44.dp,
    horizontalPadding: Dp = 18.dp,
    dividerWidth: Dp = 1.dp,
    showVerticalDividers: Boolean = true,
    backgroundColor: Color = Color(0xFFF5F8FD),
    borderColor: Color = AdminListDefaults.Border,
    labelColor: Color = AdminListDefaults.Navy
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .height(height)
            .background(AdminListDefaults.HeaderBackground)
            .padding(horizontal = horizontalPadding),
        verticalAlignment = Alignment.CenterVertically
    ) {
        columns.forEachIndexed { index, column ->
            AdminListHeaderCell(
                column = column,
                labelColor = labelColor,
                dividerColor = borderColor,
                dividerWidth = dividerWidth,
                showDivider = showVerticalDividers && index < columns.lastIndex
            )
        }
    }
}

@Composable
fun AdminListSpreadsheetRow(
    cells: List<AdminListSpreadsheetCell>,
    modifier: Modifier = Modifier,
    height: Dp? = 52.dp,
    minHeight: Dp? = null,
    horizontalPadding: Dp = 18.dp,
    dividerWidth: Dp = 1.dp,
    showVerticalDividers: Boolean = true,
    backgroundColor: Color = AdminListDefaults.Surface,
    dividerColor: Color = AdminListDefaults.Border
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .then(
                when {
                    height != null && minHeight != null -> Modifier.heightIn(min = minHeight, max = height)
                    height != null -> Modifier.height(height)
                    minHeight != null -> Modifier.heightIn(min = minHeight)
                    else -> Modifier
                }
            )
            .background(backgroundColor)
            .padding(horizontal = horizontalPadding),
        verticalAlignment = Alignment.CenterVertically
    ) {
        cells.forEachIndexed { index, cell ->
            Box(
                modifier = Modifier
                    .weight(cell.weight)
                    .fillMaxHeight()
                    .then(
                        if (showVerticalDividers && index < cells.lastIndex) {
                            Modifier.drawBehind {
                                val strokeWidthPx = dividerWidth.toPx()
                                val x = size.width - strokeWidthPx / 2f
                                drawLine(
                                    color = dividerColor,
                                    start = Offset(x, 0f),
                                    end = Offset(x, size.height),
                                    strokeWidth = strokeWidthPx
                                )
                            }
                        } else {
                            Modifier
                        }
                    )
                    .padding(horizontal = 8.dp),
                contentAlignment = if (cell.alignEnd) Alignment.CenterEnd else Alignment.CenterStart
            ) {
                cell.content()
            }
        }
    }
}

@Composable
fun AdminListSpreadsheetGridOverlay(
    weights: List<Float>,
    modifier: Modifier = Modifier,
    horizontalPadding: Dp = 18.dp,
    dividerWidth: Dp = 1.dp,
    dividerColor: Color = AdminListDefaults.Border
) {
    BoxWithConstraints(
        modifier = modifier
            .fillMaxSize()
    ) {
        val totalWeight = weights.sum().takeIf { it > 0f } ?: 1f
        val density = LocalDensity.current
        val paddingPx = with(density) { horizontalPadding.toPx() }
        val availableWidth = with(density) { maxWidth.toPx() }.let { (it - (paddingPx * 2f)).coerceAtLeast(0f) }
        Box(
            modifier = Modifier
                .fillMaxSize()
                .drawBehind {
                    val strokeWidthPx = dividerWidth.toPx()
                    var consumed = 0f
                    weights.dropLast(1).forEach { weight ->
                        consumed += weight / totalWeight
                        val x = paddingPx + (availableWidth * consumed) - strokeWidthPx / 2f
                        drawLine(
                            color = dividerColor,
                            start = Offset(x, 0f),
                            end = Offset(x, size.height),
                            strokeWidth = strokeWidthPx
                        )
                    }
                }
        )
    }
}

@Composable
private fun RowScope.AdminListHeaderCell(
    column: AdminListHeaderColumn,
    labelColor: Color,
    dividerColor: Color = Color.Transparent,
    dividerWidth: Dp = 0.dp,
    showDivider: Boolean = false
) {
    val content: @Composable () -> Unit = {
        Row(
            modifier = Modifier.padding(horizontal = 8.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = when {
                column.alignCenter -> Arrangement.Center
                column.alignEnd -> Arrangement.End
                else -> Arrangement.Start
            }
        ) {
            Text(
                text = column.label,
                color = labelColor,
                style = MaterialTheme.typography.labelLarge.copy(fontSize = AdminListTypography.TableHeader),
                fontWeight = AdminListTypography.TableHeaderWeight,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            column.trailingContent?.invoke()
        }
    }

    Box(
        modifier = Modifier
            .weight(column.weight)
            .then(if (column.onClick != null) Modifier.clickable(onClick = column.onClick) else Modifier)
            .padding(end = 6.dp)
            .then(
                if (showDivider) {
                    Modifier.drawBehind {
                        val strokeWidthPx = dividerWidth.toPx()
                        val x = size.width - strokeWidthPx / 2f
                        drawLine(
                            color = dividerColor,
                            start = Offset(x, 0f),
                            end = Offset(x, size.height),
                            strokeWidth = strokeWidthPx
                        )
                    }
                } else {
                    Modifier
                }
            ),
        contentAlignment = when {
            column.alignCenter -> Alignment.Center
            column.alignEnd -> Alignment.CenterEnd
            else -> Alignment.CenterStart
        }
    ) {
        content()
    }
}

@Composable
private fun RowScope.AdminListSortHeaderCell(
    label: String,
    weight: Float,
    selected: Boolean,
    ascending: Boolean,
    onClick: () -> Unit,
    sortable: Boolean,
    alignCenter: Boolean,
    labelColor: Color,
    selectedColor: Color,
    unselectedColor: Color
) {
    Box(
        modifier = Modifier
            .weight(weight)
            .then(if (sortable) Modifier.clickable(onClick = onClick) else Modifier)
            .padding(end = 6.dp)
    ) {
        Box(Modifier.fillMaxWidth(), contentAlignment = if (alignCenter) Alignment.Center else Alignment.CenterStart) {
            if (sortable) AdminListSortLabel(label, selected, ascending, labelColor, selectedColor, unselectedColor)
            else Text(label, color = labelColor, style = MaterialTheme.typography.labelLarge.copy(fontSize = AdminListTypography.TableHeader), fontWeight = AdminListTypography.TableHeaderWeight)
        }
    }
}

@Composable
fun AdminListSortLabel(
    text: String,
    selected: Boolean,
    ascending: Boolean,
    labelColor: Color = AdminListDefaults.Navy,
    selectedColor: Color = AdminListDefaults.Primary,
    unselectedColor: Color = AdminListDefaults.Muted,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(6.dp)
    ) {
        Text(
            text = text,
            style = MaterialTheme.typography.labelLarge.copy(fontSize = AdminListTypography.TableHeader),
            color = labelColor,
            fontWeight = AdminListTypography.TableHeaderWeight
        )
        if (selected) {
            Icon(
                painter = painterResource(if (ascending) Res.drawable.chevron_up else Res.drawable.chevron_down),
                contentDescription = if (ascending) "Ascending" else "Descending",
                tint = selectedColor,
                modifier = Modifier.size(14.dp)
            )
        } else {
            Column(verticalArrangement = Arrangement.spacedBy((-4).dp)) {
                Icon(painterResource(Res.drawable.chevron_up), null, tint = unselectedColor, modifier = Modifier.size(12.dp))
                Icon(painterResource(Res.drawable.chevron_down), null, tint = unselectedColor, modifier = Modifier.size(12.dp))
            }
        }
    }
}

@Composable
fun AdminListFooter(
    pageText: String,
    pageIndex: Int,
    pageCount: Int,
    onPageChanged: (Int) -> Unit,
    pageSize: Int,
    rowsPerPageExpanded: Boolean,
    onRowsPerPageToggle: () -> Unit,
    onRowsPerPageDismiss: () -> Unit,
    onPageSizeChanged: (Int) -> Unit,
    modifier: Modifier = Modifier,
    height: Dp = 56.dp,
    horizontalPadding: Dp = 24.dp,
    footerColor: Color = AdminListDefaults.Muted,
    borderColor: Color = AdminListDefaults.Border,
    surfaceColor: Color = AdminListDefaults.Surface,
    primaryColor: Color = AdminListDefaults.Primary,
    navyColor: Color = AdminListDefaults.Navy,
    mutedColor: Color = AdminListDefaults.Muted,
    pageSizeWidth: Dp = 82.dp,
    pageSizeHeight: Dp = 40.dp
) {
    BoxWithConstraints(modifier = modifier.fillMaxWidth()) {
        val compact = maxWidth < 760.dp
        val horizontalInset = if (compact) 12.dp else horizontalPadding
        if (compact) {
            Column(
                modifier = Modifier.fillMaxWidth().heightIn(min = height).padding(horizontal = horizontalInset, vertical = 8.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Text(
                        text = pageText,
                        style = MaterialTheme.typography.bodyMedium.copy(fontSize = AdminListTypography.Footer),
                        color = footerColor,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        modifier = Modifier.weight(1f)
                    )
                    AdminListRowsPerPageSelector(
                        pageSize, rowsPerPageExpanded, onRowsPerPageToggle, onRowsPerPageDismiss,
                        onPageSizeChanged, footerColor, borderColor, surfaceColor, navyColor, mutedColor,
                        pageSizeWidth, pageSizeHeight
                    )
                }
                AdminListPagination(
                    pageIndex, pageCount, onPageChanged, borderColor = borderColor,
                    surfaceColor = surfaceColor, primaryColor = primaryColor, navyColor = navyColor,
                    mutedColor = mutedColor,
                    modifier = Modifier.align(Alignment.CenterHorizontally).horizontalScroll(rememberScrollState())
                )
            }
        } else {
            Box(
                modifier = Modifier.fillMaxWidth().height(height).padding(horizontal = horizontalInset)
            ) {
                Text(
                    text = pageText,
                    style = MaterialTheme.typography.bodyMedium.copy(fontSize = AdminListTypography.Footer),
                    color = footerColor,
                    modifier = Modifier.align(Alignment.CenterStart)
                )
                AdminListPagination(
                    pageIndex, pageCount, onPageChanged, borderColor = borderColor,
                    surfaceColor = surfaceColor, primaryColor = primaryColor, navyColor = navyColor,
                    mutedColor = mutedColor, modifier = Modifier.align(Alignment.Center)
                )
                AdminListRowsPerPageSelector(
                    pageSize, rowsPerPageExpanded, onRowsPerPageToggle, onRowsPerPageDismiss,
                    onPageSizeChanged, footerColor, borderColor, surfaceColor, navyColor, mutedColor,
                    pageSizeWidth, pageSizeHeight, Modifier.align(Alignment.CenterEnd)
                )
            }
        }
    }
}

@Composable
private fun AdminListRowsPerPageSelector(
    pageSize: Int,
    expanded: Boolean,
    onToggle: () -> Unit,
    onDismiss: () -> Unit,
    onPageSizeChanged: (Int) -> Unit,
    footerColor: Color,
    borderColor: Color,
    surfaceColor: Color,
    contentColor: Color,
    iconTint: Color,
    width: Dp,
    height: Dp,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        Text(
            text = "Rows per page:",
            style = MaterialTheme.typography.bodyMedium.copy(fontSize = AdminListTypography.Footer),
            color = footerColor,
            maxLines = 1,
            softWrap = false
        )
        Box {
            AdminListRowsPerPageButton(
                pageSize = pageSize,
                expanded = expanded,
                onClick = onToggle,
                width = width,
                height = height,
                borderColor = borderColor,
                surfaceColor = surfaceColor,
                contentColor = contentColor,
                iconTint = iconTint
            )
            AppDropdownMenu(expanded = expanded, onDismissRequest = onDismiss) {
                PaginationPolicy.PAGE_SIZE_OPTIONS.forEach { option ->
                    Row(
                        modifier = Modifier.fillMaxWidth().height(48.dp).pointerInput(option) {
                            detectTapGestures {
                                onPageSizeChanged(option)
                                onDismiss()
                            }
                        }.padding(horizontal = 12.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) { Text("$option") }
                }
            }
        }
    }
}

@Composable
fun AdminListRowsPerPageButton(
    pageSize: Int,
    expanded: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    width: Dp = 82.dp,
    height: Dp = 40.dp,
    borderColor: Color = AdminListDefaults.Border,
    surfaceColor: Color = AdminListDefaults.Surface,
    contentColor: Color = AdminListDefaults.Navy,
    iconTint: Color = AdminListDefaults.Muted
) {
    Row(
        modifier = modifier
            .size(width = width, height = height)
            .background(surfaceColor, AdminListDefaults.CornerShape)
            .border(1.dp, borderColor, AdminListDefaults.CornerShape)
            .clickable(onClick = onClick)
            .padding(horizontal = 10.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    ) {
        Text(
            text = pageSize.toString(),
            style = MaterialTheme.typography.labelLarge.copy(fontSize = AdminListTypography.Control),
            color = contentColor,
            fontWeight = FontWeight.Medium
        )
        Spacer(modifier = Modifier.width(6.dp))
        Icon(
            painter = painterResource(Res.drawable.chevron_down),
            contentDescription = null,
            tint = iconTint,
            modifier = Modifier.size(16.dp)
        )
    }
}

@Composable
fun AdminListPagination(
    pageIndex: Int,
    pageCount: Int,
    onPageChanged: (Int) -> Unit,
    modifier: Modifier = Modifier,
    borderColor: Color = AdminListDefaults.Border,
    surfaceColor: Color = AdminListDefaults.Surface,
    primaryColor: Color = AdminListDefaults.Primary,
    navyColor: Color = AdminListDefaults.Navy,
    mutedColor: Color = AdminListDefaults.Muted
) {
    val safePageCount = pageCount.coerceAtLeast(1)
    val safePageIndex = pageIndex.coerceIn(0, safePageCount - 1)
    val visiblePages = remember(safePageIndex, safePageCount) {
        buildAdminListPagination(safePageIndex, safePageCount)
    }

    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        AdminListNavButton(
            icon = painterResource(Res.drawable.double_chevron_left),
            contentDescription = "First page",
            enabled = safePageIndex > 0,
            onClick = { onPageChanged(0) },
            borderColor = borderColor,
            surfaceColor = surfaceColor,
            mutedColor = mutedColor
        )
        AdminListNavButton(
            icon = painterResource(Res.drawable.chevron_left),
            contentDescription = "Previous page",
            enabled = safePageIndex > 0,
            onClick = { onPageChanged((safePageIndex - 1).coerceAtLeast(0)) },
            borderColor = borderColor,
            surfaceColor = surfaceColor,
            mutedColor = mutedColor
        )
        visiblePages.forEach { page ->
            when (page) {
                is AdminListPageButton.Number -> {
                    val selected = page.number - 1 == safePageIndex
                    Box(
                        modifier = Modifier
                            .size(width = 32.dp, height = 32.dp)
                            .background(
                                if (selected) primaryColor else Color.Transparent,
                                AdminListDefaults.CornerShape
                            )
                            .border(
                                if (selected) 0.dp else 1.dp,
                                if (selected) Color.Transparent else borderColor,
                                AdminListDefaults.CornerShape
                            )
                            .clickable(onClick = { onPageChanged(page.number - 1) }),
                        contentAlignment = Alignment.Center
                    ) {
                        Text(
                            text = page.number.toString(),
                            color = if (selected) Color.White else navyColor,
                            fontWeight = FontWeight.SemiBold,
                            style = MaterialTheme.typography.labelLarge
                        )
                    }
                }
                AdminListPageButton.Ellipsis -> {
                    Text(
                        text = "...",
                        color = navyColor,
                        fontWeight = FontWeight.Bold
                    )
                }
            }
        }
        AdminListNavButton(
            icon = painterResource(Res.drawable.chevron_right),
            contentDescription = "Next page",
            enabled = safePageIndex < safePageCount - 1,
            onClick = { onPageChanged((safePageIndex + 1).coerceAtMost(safePageCount - 1)) },
            borderColor = borderColor,
            surfaceColor = surfaceColor,
            mutedColor = mutedColor
        )
        AdminListNavButton(
            icon = painterResource(Res.drawable.double_chevron_right),
            contentDescription = "Last page",
            enabled = safePageIndex < safePageCount - 1,
            onClick = { onPageChanged(safePageCount - 1) },
            borderColor = borderColor,
            surfaceColor = surfaceColor,
            mutedColor = mutedColor
        )
    }
}

@Composable
private fun AdminListNavButton(
    icon: Painter,
    contentDescription: String,
    enabled: Boolean,
    onClick: () -> Unit,
    borderColor: Color,
    surfaceColor: Color,
    mutedColor: Color
) {
    Box(
        modifier = Modifier
            .size(32.dp)
            .background(surfaceColor, AdminListDefaults.CornerShape)
            .border(1.dp, borderColor, AdminListDefaults.CornerShape)
            .clickable(enabled = enabled, onClick = onClick)
            .semantics { this.contentDescription = contentDescription },
        contentAlignment = Alignment.Center
    ) {
        Icon(
            painter = icon,
            contentDescription = null,
            tint = if (enabled) mutedColor else borderColor,
            modifier = Modifier.size(16.dp)
        )
    }
}

@Composable
fun AdminListActionMenuItem(
    label: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    icon: Painter? = null,
    iconTint: Color = AdminListDefaults.Navy,
    labelColor: Color = AdminListDefaults.Navy,
    height: Dp = 40.dp
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .height(height)
            .semantics {
                role = Role.Button
                onClick {
                    onClick()
                    true
                }
            }
            .pointerInput(onClick) {
                detectTapGestures(onTap = { onClick() })
            }
            .padding(horizontal = 10.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        if (icon != null) {
            Icon(
                painter = icon,
                contentDescription = label,
                tint = iconTint,
                modifier = Modifier.size(18.dp)
            )
        }
        Text(
            text = label,
            style = MaterialTheme.typography.labelLarge.copy(fontSize = 13.sp),
            color = labelColor,
            fontWeight = FontWeight.ExtraBold
        )
    }
}

@Composable
fun AdminListActionMenuDivider(borderColor: Color = AdminListDefaults.Line) {
    HorizontalDivider(color = borderColor, modifier = Modifier.padding(vertical = 4.dp))
}

private sealed interface AdminListPageButton {
    data class Number(val number: Int) : AdminListPageButton
    data object Ellipsis : AdminListPageButton
}

private fun buildAdminListPagination(pageIndex: Int, pageCount: Int): List<AdminListPageButton> {
    if (pageCount <= 7) {
        return (1..pageCount).map { AdminListPageButton.Number(it) }
    }

    val currentPage = pageIndex + 1
    return when {
        currentPage <= 4 -> listOf(
            1, 2, 3, 4, 5
        ).map { AdminListPageButton.Number(it) } + listOf(
            AdminListPageButton.Ellipsis,
            AdminListPageButton.Number(pageCount)
        )

        currentPage >= pageCount - 3 -> listOf(
            AdminListPageButton.Number(1),
            AdminListPageButton.Ellipsis
        ) + ((pageCount - 4)..pageCount).map { AdminListPageButton.Number(it) }

        else -> listOf(
            AdminListPageButton.Number(1),
            AdminListPageButton.Ellipsis,
            AdminListPageButton.Number(currentPage - 1),
            AdminListPageButton.Number(currentPage),
            AdminListPageButton.Number(currentPage + 1),
            AdminListPageButton.Ellipsis,
            AdminListPageButton.Number(pageCount)
        )
    }
}

object AdminListDefaults {
    val Background = Color(0xFFF8FAFC)
    val Surface = Color.White
    val Border = Color(0xFFE5E7EB)
    val Line = Color(0xFFE5E7EB)
    val Navy = Color(0xFF111827)
    val PageTitleColor = com.schoolconnect.app.designsystem.AppPageHeader
    val PageSubtitleColor = com.schoolconnect.app.designsystem.AppPageSubtitle
    val Muted = Color(0xFF6B7280)
    val Primary = Color(0xFF2563EB)
    val HeaderBackground = Color(0xFFF1F5F9)
    val HoverRow = Color(0xFFF3F8FF)
    val SelectedRow = Color(0xFFE8F2FF)
    val CornerShape = androidx.compose.foundation.shape.RoundedCornerShape(8.dp)
    val CircleShape = androidx.compose.foundation.shape.RoundedCornerShape(100)
}

/** Canonical typography for every shared admin list page. */
object AdminListTypography {
    val PageTitle = 28.sp
    val PageTitleWeight = FontWeight.SemiBold
    val PageSubtitle = 14.sp
    val PageSubtitleWeight = FontWeight.Normal
    // Match Dashboard MetricCard: titleSmall/Bold, headlineSmall/ExtraBold, bodyMedium.
    val SummaryTitle = 14.sp
    val SummaryTitleWeight = FontWeight.Bold
    val SummaryValue = 24.sp
    val SummaryValueWeight = FontWeight.ExtraBold
    val SummarySubtitle = 14.sp
    val SummarySubtitleWeight = FontWeight.Normal
    val TableHeader = 13.sp
    val TableHeaderWeight = FontWeight.SemiBold
    val TableBody = 14.sp
    val TableBodyWeight = FontWeight.Normal
    val TableBodyWeightStrong = FontWeight.Medium
    val Control = 14.sp
    val ControlWeight = FontWeight.Medium
    val ControlWeightStrong = FontWeight.SemiBold
    val Footer = 14.sp
}

@Composable
fun AdminListTableBodyText(
    text: String,
    modifier: Modifier = Modifier,
    color: Color = AdminListDefaults.Navy,
    fontWeight: FontWeight = AdminListTypography.TableBodyWeight,
    maxLines: Int = 1
) {
    Text(
        text = text,
        modifier = modifier,
        color = color,
        fontSize = AdminListTypography.TableBody,
        fontWeight = AdminListTypography.TableBodyWeight,
        maxLines = maxLines,
        overflow = TextOverflow.Ellipsis
    )
}
